import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { AboutSection } from '../components/AboutSection';
export function TeamPage() {
  return <>
      <PageHeader title="Our Team" backgroundImage="https://images.unsplash.com/photo-1582750433449-648ed127bb54?auto=format&fit=crop&w=1920&q=80" data-id="element-1106" />
      <AboutSection data-id="element-1107" />
    </>;
}